import type { Site } from '@hotjar/site';
import { show } from '@hotjar/webapp/domains/activation/tracking-code/show-tracking-code';

interface ModalTrackingCodeFunctions {
  show: (site: Site, activeTab: number, source: string) => void;
}

const modalTrackingCodeFunctions = {
  show: (site: Site, activeTab: number, source: string) => show(site, activeTab, source),
};

export const useModalTrackingCode = (): ModalTrackingCodeFunctions => modalTrackingCodeFunctions;
